import { getYear, isAfter, subWeeks } from 'date-fns'

import type { HoldingWeekDto } from '@hcr/api/consumer'
import { filter, flow, group, sort } from '@hcr/utils'

import { compareDates, toDestinationDate } from '../../../../../../utils'

export const prepareWeekPreviewsData = flow(
  filter<HoldingWeekDto>(week => isAfter(toDestinationDate(week.week_end), subWeeks(toDestinationDate(new Date()), 1))),
  sort<HoldingWeekDto>({
    comparer: compareDates,
    asc: 'week_start',
  }),
  group(week => String(getYear(toDestinationDate(week.week_start))))
)
